<template>
  <!-- 推荐商品管理 -->
  <div class="recommendGoods">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['权限管理', $route.meta.title]"
    >
      <template slot="controls">
        <span>暂未使用</span>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >添加推荐</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">位置选择：</label>
        <el-select
          v-model="searchForm.position"
          placeholder="位置选择"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="-1"></el-option>
          <el-option
            v-for="item in options"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
          <!-- <el-option label="购物车" value="0"></el-option>
          <el-option label="结算成功" value="1"></el-option> -->
        </el-select>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="-1"></el-option>
          <el-option label="已上架" value="1"></el-option>
          <el-option label="已下架" value="0"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入商品名/助忆词"
          @keyup.enter.native="getTableData"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="sub_title"
        show-overflow-tooltip
        label="商品名"
      >
      </el-table-column>
      <el-table-column
        prop="mnemonic_code"
        align="center"
        show-overflow-tooltip
        label="助记码"
      >
      </el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="approval_number"
        label="国药准字"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="package_unit"
        label="包装单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="dosage_form"
        label="剂型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="推荐位置"
        align="center"
        :formatter="statewzFormat"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        :formatter="stateFormat"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 1"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleOut(scope.row)"
            >下架</el-button
          >
          <el-button
            v-if="scope.row.status == 0"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handlePut(scope.row)"
            >上架</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row)"
            >删除</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 新增推荐商品 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">新增推荐商品</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="推荐商品" prop="name">
              <el-input
                @click.native="addGoodName"
                v-model="addForm.name"
                placeholder="请输入商品名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="位置类型" prop="recommPosition">
              <el-select
                v-model="addForm.recommPosition"
                placeholder="位置类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.Code"
                  :label="item.Name"
                  :value="item.Code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="addForm.status"
                placeholder="状态"
                style="width: 100%"
              >
                <el-option label="已上架" value="1"></el-option>
                <el-option label="已下架" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input v-model="addForm.sort" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
    <!-- 绑定商品dialog -->
    <el-dialog
      title="商品列表"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="ouZone">
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm2.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getspTableData"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="goodData"
        stripe
        border
        @row-click="rowClick"
        tooltip-effect="dark"
        style="width: 100%; height: 500px; overflow: auto"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column type="selection" align="center" width="55">
        </el-table-column> -->
        <el-table-column
          align="center"
          prop="keyid"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="sub_title"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_spec"
          label="商品规格"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="price_ck"
          label="建议零售价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="stock_quantity"
          label="库存"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_factory"
          label="生产厂家"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="big_package"
          label="件装量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "recommendGoods",
  data() {
    return {
      /**表格数据 */
      // {
      //   name:"商品名",
      //   helpCode:"助记码",
      //   producer:"生产厂家",
      //   SFDA:"国药准字",
      //   specification:"商品规格",
      //   packingNnit:"包装单位",
      //   type:"剂型",
      //   recommPosition:"推荐位置",
      //   status:"状态"
      // }
      tableData: [],
      goodData: [],
      options: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      dialogVisible: false,
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,
      /**搜索表单 */
      searchForm: {
        position: "-1",
        status: "1",
        name: "",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增表单 */
      //推荐商品 位置类型 状态 排序
      addForm: {
        name: "",
        id: "",
        oldid: "",
        gg: "",
        sccj: "",
        zbz: "",
        kc: "",
        je: "",
        recommPosition: "",
        oldrecommPosition: "",
        status: "0",
        sort: "",
      },
      /**新增表单规则 */
      addFormRule: {},
      /**搜索表单 */
      searchForm2: {
        name: "",
      },
    };
  },
  mounted() {
    this.LoadImgType();
    this.getTableData();
    this.getspTableData();
  },
  methods: {
    updata() {
      this.LoadImgType();
      this.getTableData();
      this.getspTableData();
    },
    stateFormat(row) {
      if (row.status === 0) {
        return "下架";
      } else {
        return "上架";
      }
    },
    statewzFormat(row) {
      for (const index in this.options) {
        if (row.type == this.options[index].Code) {
          return this.options[index].Name;
        }
      }
    },
    //获取分类
    LoadImgType() {
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx",
        data: {
          json: "{'type':'GoodsRecommendType'}",
          type: "GoodsRecommendType",
          proc: "",
        },
        method: "Post",
      })
        .then((res) => {
          this.options = res.data;
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    addGoodName() {
      this.dialogVisible = true;
    },
    /**获取商品表格 */
    getspTableData() {
      var strWhere = this.searchForm2.name;
      var pageIndex = this.currPage2;
      var pageSize = this.pageSize2;
      var type = "ReturnDataSet";
      var proc = "Proc_Admin_SearchInfo";
      var data = {
        type: "GoodsListHG",
        strWhere: strWhere,
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      this.$requestSys({
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          encodeURIComponent(type) +
          "&proc=" +
          encodeURIComponent(proc),
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodData = res.content;
            this.allPage2 = res.recordCount;
          } else {
            if (pageSize == 1) {
              this.goodData = [];
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    rowClick(row) {
      this.row = row;
      this.addForm.name = row.sub_title;
      this.addForm.id = row.keyid;
      this.addForm.gg = row.drug_spec;
      this.addForm.sccj = row.drug_factory;
      this.addForm.zbz = row.min_package;
      this.addForm.kc = row.stock_quantity;
      this.addForm.je = row.price_ck;
      this.dialogVisible = false;
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      var data = JSON.stringify({
        type: "GoodsRecommendList",
        code: this.searchForm.position,
        status: this.searchForm.status,
        soustr: this.searchForm.name,
        pageindex: this.currPage,
        pagesize: this.pageSize,
      });
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx",
        data: {
          type: "GoodsRecommendList",
          proc: "",
          json: data,
        },
        method: "Post",
      })
        .then((res) => {
          this.allPage = res.recordCount || 0;
          this.tableData = res.data || [];
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getspTableData();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getspTableData();
    },

    /**点击新增 */
    handleAdd() {
      // this.addDrawer = true;
      this.$router.push("AddComm");
    },
    /**点击修改 */
    handleEdit(row) {
      this.addForm.oldid = row.article_id;
      this.addForm.name = row.sub_title;
      this.addForm.id = row.article_id;
      this.addForm.gg = row.drug_spec;
      this.addForm.sccj = row.drug_factory;
      this.addForm.zbz = row.min_package;
      this.addForm.kc = row.stock_quantity;
      this.addForm.je = row.price_ck;
      this.addForm.sort = row.sort;
      this.addForm.oldrecommPosition = row.type;
      this.addForm.status = String(row.status);
      this.addForm.recommPosition = row.type;
      this.addDrawer = true;
    },
    /**点击删除 */
    handleDel(row) {
      this.$confirm("确定删除该条数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$requestSys({
            url: "goods/ashx/ReturnJson.ashx",
            data: {
              json:
                "{'type':'DeleteGoodsRecommend','articleid':'" +
                row.article_id +
                "','code':'" +
                row.type +
                "'}",
              type: "DeleteGoodsRecommend",
              proc: "",
            },
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 1) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "info",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**点击下架 */
    handleOut(row) {
      this.handleshow(row.article_id, row.type, 0);
    },
    /**点击上架 */
    handlePut(row) {
      this.handleshow(row.article_id, row.type, 1);
    },
    handleshow(articleid, type, status) {
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx",
        data: {
          json:
            "{'type':'StatusGoodsRecommend','articleid':'" +
            articleid +
            "','code':'" +
            type +
            "','status':'" +
            status +
            "'}",
          type: "StatusGoodsRecommend",
          proc: "",
        },
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 1) {
            if (status == 1) {
              this.$message({
                message: "上架成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "下架成功",
                type: "success",
              });
            }
            this.getTableData();
          } else {
            this.$message({
              message: res.message,
              type: "info",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.$refs["addForm"].resetFields();
      for (const key in this.addForm) {
        this.addForm[key] = null;
      }
      this.addDrawer = false;
    },
    /**提交表单 */
    submit() {
      var articleid = this.addForm.id;
      var old_articleid = this.addForm.oldid;
      var type = this.addForm.recommPosition;
      var old_type = this.addForm.oldrecommPosition;
      var status = this.addForm.status;
      var sort = this.addForm.sort;
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx",
        data: {
          json:
            "{'type':'UpdateGoodsRecommend','articleid':'" +
            articleid +
            "','old_articleid':'" +
            old_articleid +
            "','code':'" +
            type +
            "','old_type':'" +
            old_type +
            "','status':'" +
            status +
            "','sort':'" +
            sort +
            "'}",
          type: "UpdateGoodsRecommend",
          proc: "",
        },
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 1) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$message({
              message: res.message,
              type: "info",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.recommendGoods {
  width: 100%;
  height: 100%;
}
</style>
